import { SendSMSTemplate } from 'views/templates/sendSMS';
import { useSendSMS } from './hooks';

export const SendSMS = () => {
  const tempProps = useSendSMS();
  return <SendSMSTemplate {...tempProps} />;
};
